<template>
  <div id="approved-projects" class="clearfix gibson px2 mb4">
    <div class="col-12">
          <div class="clearfix">
            <div class="col-12 mt2 px0 flex justify-between items-center">
                <p class="h1 regular line-height-2 my3">Godkendte projekter</p>
            </div>
            <div v-if="loading">
              <div class="col-12">
                <div class="loader"></div>
              </div>
            </div>
            <div :class="loading ? 'hide' : ''" v-if="!formLoading">
              <div class="flex flex-wrap" v-if="approvedProjectsData.length > 0">
                <div class="col-3 p2" :class="!proj.OFFER_SENT ? 'flex' : null" v-for="(proj, index) in approvedProjectsData" :key="index">
                  <div class="col-12 p0 border highlights py3 px2 mb2">
                    <img :src="proj.ADDRESS.IMAGE" rel="preload" width="100%" height="250px" class="mb3 cover" :alt="proj.ADDRESS ? proj.ADDRESS : 'No Image'" v-if="proj.ADDRESS">
                    <div class="flex justify-center items-center mb3" style="height:250px;" v-else>
                      <img src="" alt="No image">
                    </div>
                    <h3 class="darkblue">{{proj.NAME ? proj.NAME : null}}</h3>
                    <p class="mb0">{{proj.ADDRESS ? proj.ADDRESS.ADDRESS : null}}</p>
                    <p>{{proj.ADDRESS ? proj.ADDRESS.ZIP_CODE : null}}</p>
                    <h5 class="darkblue mb3">{{proj.QUICK_OUTLINE ? proj.QUICK_OUTLINE : null}}</h5>
                    <div class="flex justify-between">
                      <h5 class="darkblue">{{proj.HOMEOWNER && proj.HOMEOWNER.NAME ? proj.HOMEOWNER.NAME : null}}</h5>
                      <p class="darkblue">{{proj.DATE_CREATED ? proj.DATE_CREATED.split(' ')[0] : null}}</p>
                    </div>
                    <div class="flex flex-wrap mb2" v-if="proj.TAGS != null && proj.TAGS.length > 0">
                      <el-tag
                        v-for="tag in proj.TAGS"
                        :key="tag.ID"
                        effect="dark"
                        class="mr1 mb2">
                        <span class="cap">{{ tag.DA_DK }}</span>
                      </el-tag>
                    </div>
                    <div class="mb4" v-else></div>
                    <div class="center">
                      <div class="mb1">
                        <button class="h5 action-button py2 px3 m0 gibson not-rounded border-none regular col-12" @click="createOffer('standard', proj.ID, proj.HOMEOWNER, proj.ADDRESS.ADDRESS)">Standard tilbud</button>
                      </div>
                      <div class="mb1">
                        <button class="h5 action-button py2 px3 m0 gibson not-rounded border-none regular col-12" @click="createOffer('hurtigt', proj.ID, proj.HOMEOWNER, proj.ADDRESS.ADDRESS)">Hurtigt Offer</button>
                      </div>
                      <div class="mb1">
                        <button class="h5 action-button py2 px3 m0 gibson not-rounded border-none regular col-12" @click="createOffer('upload', proj.ID, proj.HOMEOWNER, proj.ADDRESS.ADDRESS)">Upload tilbud</button>
                      </div>
                    </div>
                    <!-- <form @submit.stop.prevent="!proj.OFFER_SENT ? sendOffer(proj.HOMEOWNER, proj.ID) : ''" v-if="!proj.OFFER_SENT">
                      <div :id="'offerDetails-' + proj.ID" :class="proj.OFFER_SENT ? 'no-events opacity-50' : ''">
                        <div :id="cat.value" class="offerDetailsForm mb2" v-for="(cat, index) in categoriesData" :key="index">
                          <div class="form-group">
                            <div class="flex flex-wrap justify-between">
                              <p class="h5 darkblue m0">{{cat.label}}</p>
                              <i class="h4 primarycolor pointer el-icon-circle-plus-outline" :title="'Tilføj ' + cat.label + ' felter'" @click="addOfferDetailsForm(proj.ID, cat.value)"></i>
                            </div>
                            <input type="hidden" id="offer_categories" placeholder="Kategori" class="h5 col-12 el-input__inner" :value="cat.value" required>
                          </div>
                          <div class="offerDetails">
                            <div class="flex flex-wrap details index-0">
                              <div class="col-6 p0 pr1 form-group">
                                <input id="offer_title" placeholder="Titel" class="h5 col-12 el-input__inner m0" required>
                              </div>
                              <div class="col-6 p0 pl1 form-group">
                                <input id="offer_value" placeholder="Værdi" class="h5 col-12 el-input__inner m0" required>
                              </div>
                              <div class="col-12 p0">
                                <i class="removeForm h4 red pointer block right-align el-icon-remove-outline" title="Fjern felter"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="form-group mb3">
                          <div class="el-input el-input-group el-input-group--append">
                            <input type="number" id="price" placeholder="Pris" class="h5 col-12 el-input__inner m0" required>
                            <div class="el-input-group__append">kr</div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <button :type="proj.OFFER_SENT ? 'button' : 'submit'" class="h5 action-button py2 px3 m0 mb1 gibson not-rounded border-none regular col-12" :disabled="proj.OFFER_SENT ? true : false">{{proj.OFFER_SENT ? 'Offer Sent' : 'Send Offer'}}</button>
                      </div>
                    </form>
                    <div v-else>
                     <button type="button" class="h5 action-button py2 px3 m0 mb1 gibson not-rounded border-none regular col-12 no-events" disabled>Offer Sent</button>
                    </div> -->
                  </div>
                </div>
              </div>
              <div class="mt4" v-else>
                <p class="h5 center regular easternblue m0 p0">No data</p>
              </div>
                    <!-- <form @submit.stop.prevent="!proj.OFFER_SENT ? sendOffer(proj.HOMEOWNER, proj.ID) : ''" v-if="!proj.OFFER_SENT">
                      <div :id="'offerDetails-' + proj.ID" :class="proj.OFFER_SENT ? 'no-events opacity-50' : ''">
                        <div :id="cat.value" class="offerDetailsForm mb2" v-for="(cat, index) in categoriesData" :key="index">
                          <div class="form-group">
                            <div class="flex flex-wrap justify-between">
                              <p class="h5 darkblue m0">{{cat.label}}</p>
                              <i class="h4 primarycolor pointer el-icon-circle-plus-outline" :title="'Tilføj ' + cat.label + ' felter'" @click="addOfferDetailsForm(proj.ID, cat.value)"></i>
                            </div>
                            <input type="hidden" id="offer_categories" placeholder="Kategori" class="h5 col-12 el-input__inner" :value="cat.value" required>
                          </div>
                          <div class="offerDetails">
                            <div class="flex flex-wrap details index-0">
                              <div class="col-6 p0 pr1 form-group">
                                <input id="offer_title" placeholder="Titel" class="h5 col-12 el-input__inner m0" required>
                              </div>
                              <div class="col-6 p0 pl1 form-group">
                                <input id="offer_value" placeholder="Værdi" class="h5 col-12 el-input__inner m0" required>
                              </div>
                              <div class="col-12 p0">
                                <i class="removeForm h4 red pointer block right-align el-icon-remove-outline" title="Fjern felter"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="form-group mb3">
                          <div class="el-input el-input-group el-input-group--append">
                            <input type="number" id="price" placeholder="Pris" class="h5 col-12 el-input__inner m0" required>
                            <div class="el-input-group__append">kr</div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <button :type="proj.OFFER_SENT ? 'button' : 'submit'" class="h5 action-button py2 px3 m0 mb1 gibson not-rounded border-none regular col-12" :disabled="proj.OFFER_SENT ? true : false">{{proj.OFFER_SENT ? 'Offer Sent' : 'Send Offer'}}</button>
                      </div>
                    </form>
                    <div v-else>
                    <button type="button" class="h5 action-button py2 px3 m0 mb1 gibson not-rounded border-none regular col-12 no-events" disabled>Offer Sent</button>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          <!-- </div> -->
      <!-- </div>
  </div> -->
</template>

<script>
export default {
  components: {
  },
  created () {
    this.displayCurrentProject()
  },
  data () {
    return {
      haaId: localStorage.getItem('haaid'),
      salesPerson: localStorage.getItem('id_token_portalbitrix'),
      loading: true,
      formLoading: false,
      currentProjectData: {},
      approvedProjectsData: [],
      categoriesData: [{
        value: 'price_details',
        label: 'Price Details'
      },
      {
        value: 'guarantee',
        label: 'Guarantee'
      },
      {
        value: 'materials',
        label: 'Materials'
      },
      {
        value: 'add-ons',
        label: 'Add-ons'
      }]
    }
  },
  methods: {
    displayApprovedProjects () {
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      var data = {}
      this.$http.get(process.env.BITRIXAPI + 'partner/projects/approved', { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body.data
          if (res !== null && res.length > 0) {
            this.approvedProjectsData = res.sort((a, b) => Number(a.OFFER_SENT) - Number(b.OFFER_SENT))
          }
          this.loading = false
          this.formLoading = false
        },
        response => {
          this.loading = false
          this.formLoading = false
          var error = response.body
          if (error && error.constructor.name !== 'Object') {
            if (!error.includes('Unauthorized')) {
              if (error.data && error.data !== null) {
                for (var message of Object.values(error)) {
                  this.$message({
                    type: 'error',
                    message: message[0]
                  })
                }
              } else {
                this.$message({
                  type: 'error',
                  message: error.message
                })
              }
            } else {
              this.$router.push('/login')
            }
          } else {
            this.$message({
              type: 'error',
              message: error.message
            })
          }
        }
      )
    },
    displayCurrentProject () {
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      var data = {}
      this.$http.get(process.env.BITRIXAPI + 'partner/projects', { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body.data
          if (res !== null && res.length > 0) {
            for (var i = 0; i < res.length; i++) {
              if (res[i].IS_ACTIVE === 1) {
                this.currentProjectData = res[i]
              }
            }
          }
          this.displayApprovedProjects()
        },
        response => {
          this.loading = false
          var error = response.body
          if (error && error.constructor.name !== 'Object') {
            if (!error.includes('Unauthorized')) {
              if (error.data && error.data !== null) {
                for (var message of Object.values(error)) {
                  this.$message({
                    type: 'error',
                    message: message[0]
                  })
                }
              } else {
                this.$message({
                  type: 'error',
                  message: error.message
                })
              }
            } else {
              this.$router.push('/login')
            }
          } else {
            this.$message({
              type: 'error',
              message: error.message
            })
          }
        }
      )
    },
    addOfferDetailsForm (projId, category) {
      var detailsForm = document.querySelector('#offerDetails-' + projId + ' #' + category + ' .details')
      var clonedForm = detailsForm.cloneNode(true)
      document.querySelector('#offerDetails-' + projId + ' #' + category + ' .offerDetails').appendChild(clonedForm)
      var offerTitle = document.querySelector('#offerDetails-' + projId + ' #' + category + ' .details:last-child #offer_title')
      var offerValue = document.querySelector('#offerDetails-' + projId + ' #' + category + ' .details:last-child #offer_value')
      offerTitle.value = ''
      offerValue.value = ''
      var loopdetailsForm = document.querySelectorAll('#offerDetails-' + projId + ' #' + category + ' .offerDetails .details')
      var loopdetailsRemoveBtn = document.querySelectorAll('#offerDetails-' + projId + ' #' + category + ' .offerDetails .details .removeForm')
      for (var i = 0; i < loopdetailsForm.length; i++) {
        loopdetailsForm[i].removeAttribute('class')
        loopdetailsForm[i].classList.add('flex', 'flex-wrap', 'justify-between', 'details', 'index-' + i)
      }
      for (var x = 0; x < loopdetailsRemoveBtn.length; x++) {
        loopdetailsRemoveBtn[x].removeAttribute('id')
        loopdetailsRemoveBtn[x].setAttribute('id', 'removeForm-' + x)
        loopdetailsRemoveBtn[x].addEventListener('click', function (e) {
          var offerForm = document.querySelector('#offerDetails-' + projId + ' #' + category + ' .offerDetails .details.index-' + e.target.id.split('-')[1])
          if (offerForm !== null) {
            offerForm.remove()
          }
        })
      }
    },
    removeOfferDetailsForm (category) {
      console.log(category)
    },
    createOffer (type, projId, homeOwnerData, address) {
      this.$confirm('Er du sikker?', 'Send tilbud', {
        confirmButtonText: 'OK',
        cancelButtonText: '',
        type: 'warning'
      }).then(() => {
        var offer = ''
        if (type === 'standard') {
          offer = 'standardTilbud'
        } else if (type === 'hurtigt') {
          offer = 'hurtigt-tilbud'
        } else {
          offer = 'upload-tilbud'
        }
        this.$router.push('/tilbud/' + offer + '?projectId=' + projId + '&contactId=' + homeOwnerData.ID + '&name=' + homeOwnerData.NAME + '&email=' + homeOwnerData.EMAIL + '&mobile=' + homeOwnerData.MOBILE + '&address=' + address)
      }).catch(() => {
      })
    }
    // sendOffer (contactId, projId) {
    //   this.loading = true
    //   var offerDetailsForm = document.querySelectorAll('#offerDetails-' + projId + ' .offerDetailsForm')
    //   var price = document.querySelector('#offerDetails-' + projId + ' #price').value
    //   var offerCat = ''
    //   var offerTitle = ''
    //   var offerValue = ''
    //   var offerDetails = []
    //   var details = ''
    //   for (var i = 0; i < offerDetailsForm.length; i++) {
    //     offerCat = offerDetailsForm[i].id
    //     details = document.querySelectorAll('#offerDetails-' + projId + ' #' + offerCat + ' .offerDetails .details')
    //     for (var x = 0; x < details.length; x++) {
    //       offerTitle = document.querySelector('#offerDetails-' + projId + ' #' + offerCat + ' .offerDetails .details.index-' + x + ' #offer_title').value
    //       offerValue = document.querySelector('#offerDetails-' + projId + ' #' + offerCat + ' .offerDetails .details.index-' + x + ' #offer_value').value
    //       offerDetails.push({
    //         category: offerCat,
    //         itemTitle: offerTitle,
    //         itemValue: offerValue
    //       })
    //     }
    //   }
    //   var headers = {
    //     Authorization: 'Bearer ' + this.salesPerson
    //   }
    //   var data = {
    //     offerDetails
    //   }
    //   this.$http.post(process.env.BITRIXAPI + 'partner/project/' + projId + '/offer?contactId=' + contactId + '&price=' + price, data, { headers }, { emulateJSON: true }).then(
    //     response => {
    //       this.$message({
    //         type: 'success',
    //         message: 'Success'
    //       })
    //       this.formLoading = true
    //       this.displayApprovedProjects()
    //     },
    //     response => {
    //       this.loading = false
    //       var error = response.body
    //       if (error && error.constructor.name !== 'Object') {
    //         if (!error.includes('Unauthorized')) {
    //           if (error.data && error.data !== null) {
    //             for (var message of Object.values(error)) {
    //               this.$message({
    //                 type: 'error',
    //                 message: message[0]
    //               })
    //             }
    //           } else {
    //             console.log('1', error.data)
    //             this.$message({
    //               type: 'error',
    //               message: error.message
    //             })
    //           }
    //         } else {
    //           this.$router.push('/login')
    //         }
    //       } else {
    //         this.$message({
    //           type: 'error',
    //           message: error.message
    //         })
    //       }
    //     })
    // }
  }
}
</script>
<style>
  #approved-projects .el-input__inner {
    -webkit-appearance: auto;
  }
  #approved-projects .offerDetailsForm .offerDetails .details:first-child .removeForm {
    display: none;
  }
  #approved-projects input::-webkit-outer-spin-button,
  #approved-projects input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  #approved-projects input[type=number] {
    -moz-appearance: textfield;
  }
  .loader,
  .loader:before,
  .loader:after {
    border-radius: 50%;
  }
  .loader {
    color: #143130;
    font-size: 11px;
    text-indent: -99999em;
    margin: 55px auto;
    position: relative;
    width: 10em;
    height: 10em;
    box-shadow: inset 0 0 0 1em;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
  }
  .loader:before,
  .loader:after {
    position: absolute;
    content: '';
  }
  .loader:before {
    width: 5.2em;
    height: 10.2em;
    background: white;
    border-radius: 10.2em 0 0 10.2em;
    top: -0.1em;
    left: -0.1em;
    -webkit-transform-origin: 5.2em 5.1em;
    transform-origin: 5.2em 5.1em;
    -webkit-animation: load2 2s infinite ease 1.5s;
    animation: load2 2s infinite ease 1.5s;
  }
  .loader:after {
    width: 5.2em;
    height: 10.2em;
    background: white;
    border-radius: 0 10.2em 10.2em 0;
    top: -0.1em;
    left: 5.1em;
    -webkit-transform-origin: 0px 5.1em;
    transform-origin: 0px 5.1em;
    -webkit-animation: load2 2s infinite ease;
    animation: load2 2s infinite ease;
  }
  @-webkit-keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
</style>


// WEBPACK FOOTER //
// ApprovedProjects.vue?6ebc3484